import { BrowserModule,  } from '@angular/platform-browser';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA } from '@angular/core';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { AppRoutingModule } from './app-routing.module';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { AppComponent } from './app.component';
import { EnrollComponent } from './enroll/enroll.component';
import { LoginComponent } from './login/login.component';
import { ApplicationComponent } from './application/application.component';
import { ViewComponent } from './view/view.component';
import { RouterModule, Routes } from '@angular/router';
import { Observable } from 'rxjs';
import { LoadingService } from './loading/loading.service';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
// import '@angular/compiler';
// material.module.ts
import { ModuleWithProviders } from "@angular/core";
import { MAT_LABEL_GLOBAL_OPTIONS, MatNativeDateModule, MAT_DATE_LOCALE } from '@angular/material/core';
import { MaterialModule } from './shared/material.module';
import { BackendService } from './shared/backend.service';
// import { NotificationComponent } from './notification/notification.component';
// import { NotificationService } from './notification/notification.service';
import { PopupdisplayComponent } from './popupdisplay/popupdisplay.component';
import { AlertmessageService } from './shared/alertmessage.service';
import { DashboardComponent } from './dashboard/dashboard.component';
import { OrderByService } from './shared/orderby.service';
import { PaginationService } from './shared/pagination.service';
import { PaginationComponent } from './shared/pagination.component';
import { PasswordResendComponent } from './login/password-resend.component';
import { ResetFormService } from './login/reset-form.service';
import { ResetQuestionsComponent } from './reset-questions/reset-questions.component';
import { ProfileComponent } from './profile/profile.component';

import {passwordStrength} from './profile/password-strength.component';
import{passwordvalid} from './enroll/passwordvalid.component';
//import{passwordvalidstr} from './reset-questions/passwordvalidstr.component'
//import{passwordvalidstr} from './reset-questions/passwordvalidstr.component'


import { AccountComponent } from './account/account.component';
import { DatePipe } from '@angular/common';
import { NotificationService } from './notification.service';
import { NotificationComponent } from './notification/notification.component';
import { AuthGuard } from './guards/auth.guard';
import { MainpageComponent } from './mainpage/mainpage.component';
import { BusinessEnrollComponent } from './business-enroll/business-enroll.component';
import { UnsubsribedComponent } from './unsubsribed/unsubsribed.component';

// import { NotificationService } from './notification/notification.service';
@NgModule({
  declarations: [
    AppComponent,
    EnrollComponent,
    LoginComponent,
    ApplicationComponent,
    ViewComponent,
    //NotificationComponent,
    DashboardComponent,
    PasswordResendComponent,
    ResetQuestionsComponent,
    ProfileComponent,
    AccountComponent,
    NotificationComponent,
    MainpageComponent,
    PaginationComponent,
    BusinessEnrollComponent,
    UnsubsribedComponent,
    
  ],
  entryComponents: [AppComponent, PopupdisplayComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule, 
    ReactiveFormsModule,
    BrowserAnimationsModule,
   // HttpModule,
    HttpClientModule,
    MaterialModule,
  ],

  providers: [
    LoadingService,
    BackendService,
    NotificationService,
    AlertmessageService,
    OrderByService,
    PaginationService,
    ResetFormService,
    DatePipe,
    AuthGuard
  ],
  bootstrap: [AppComponent],
  schemas: [
 CUSTOM_ELEMENTS_SCHEMA,
 NO_ERRORS_SCHEMA
  ]
})
export class AppModule { }



